import formatDecimal from './formatters';

export const formatRate = (row, offerType, rateType) => formatDecimal(row[offerType]?.[rateType]);

export const rateStatus = (row, offerType, rateType) => {
  if (row[offerType]) {
    if (
      offerType === 'preoffer'
      && !row.preofferSelectable?.selectable
      && !['EVALUATING', 'PENDINGDOCUMENTS'].includes(
        row.preoffer?.preofferevaluationrequest?.status,
      )
    ) {
      return 'N/D';
    }

    return formatRate(row, offerType, rateType);
  }

  return 'N/D';
};
